import mobileMenuTrigger from '../components/mobile-menu-trigger.js'
import megaMenu from '../components/mega-menu.js'
import stickyElements from '../components/sticky-elements'
import mobileMenu from '../components/mobile-menu.js'

const header = {
    settings: {
        siteHeader: document.querySelector('.c-header__primary'),
        menuList: document.querySelector('.c-navigation__list'),
        menuItem: document.querySelectorAll('.c-navigation__item')
    },
    init: function() {
        const settings = this.settings
        if (settings.siteHeader) {
            const mobileMenuButton = new mobileMenuTrigger('js-toggle-menu', 'menu-button--active', 'c-navigation', 'c-navigation__mobile-active')
            mobileMenuButton.init()
            stickyElements(settings.siteHeader, 'c-header__primary--is-sticky', 'c-header__primary--is-hidden', 139, 'c-header__primary--has-transition')
            if (settings.menuList && settings.menuItem.length) {
                megaMenu(settings.menuList, settings.menuItem)
                mobileMenu(settings.menuItem)
            }
        }
    }

}

export default header